import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

import * as layers from "@styles/emotion-styles/layers";
import * as timing from "@styles/emotion-styles/timing";

export const sideMenu = (theme: Theme) => css`
  z-index: ${layers.indexUnder};
  padding: 2.25rem 2rem 2.25rem 1.5rem;
  margin-left: -0.5rem;
  height: 42.8125rem;
  max-height: 100%;
  overflow-y: auto;
  background-color: ${theme.system.backgroundMuted};
  transition: transform ${timing.moderate} ease-in-out;
  transform-origin: left;
  transform: translateX(-18.75rem) scaleX(0);
  will-change: transform;
  position: absolute;
  left: 100%;
  top: 0;
  bottom: 0;
  border-radius: 0 0 ${borders.radiusBase} ${borders.radiusBase};

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const open = css`
  transform: translateX(0) scaleX(1);
  box-shadow: 0 4px 16px 0 #36485c29;
`;
